<template>
  <div class="operation">
    <img src="../assets/inf.png" alt="">
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang='less'>
.operation{
    width: 70%;
    margin: 0 auto;
    img{
        width: 100%;
    }
}
</style>